export default __webpack_public_path__ + "static/media/adel_1800_gold.4e37b9a6.jpg";